/**
 * The app's frame: the sidebar and the phone's „მეტი", the header and its
 * bell, the tab capsule, the lock screen, the connection strip, the loading
 * and locked-shop screens, the error screen, the branch menu and the camera.
 */
export const shell = {
  'nav.warehouse': 'საწყობი',
  'nav.pos': 'POS სალარო',
  'nav.suppliers': 'მომწოდებლები',
  'nav.credit': 'ნისია',
  'nav.accounting': 'ბუღალტერია',
  'nav.staff': 'თანამშრომლები',
  'nav.tools': 'ხელსაწყოები',
  'nav.repairs': 'შეკეთება',
  'nav.orders': 'ონლაინ შეკვეთები',
  'nav.guide': 'სახელმძღვანელო',
  'nav.settings': 'პარამეტრები',
  'nav.platform': 'პლატფორმა',
  'nav.terminal': 'ტერმინალი',

  'module.warehouse.sub': 'პროდუქციის მართვა',
  'module.pos.sub': 'სალაროს ოპერაციები',
  'module.suppliers.sub': 'შესყიდვები და ვალები',
  'module.credit.sub': 'კლიენტების ვალები',
  'module.repairs.sub': 'მიღება, სტატუსი, გაცემა',
  'module.orders.sub': 'საიტიდან შემოსული შეკვეთები',
  'module.accounting.sub': 'ანგარიშები & ანალიტიკა',
  'module.guide.sub': 'როგორ ვიმუშაო სისტემაში',
  'module.staff.sub': 'მოლარეები და ცვლები',
  'module.settings.sub': 'სისტემის კონფიგურაცია',
  'terminal.detail': 'ფასი · მიღება · თვლა სკანერით',

  'role.cashier': 'მოლარე',
  'role.owner': 'მფლობელი',
  'shell.onShift': 'ცვლაზე: {name}',
  'shell.noShift': 'ცვლა დახურულია',
  'shell.version': 'ვერსია {v}',
  'shell.builtAt': 'აწყობილია {at}',
  'role.accountant': 'ბუღალტერი',

  'shell.signedOut': 'სისტემიდან გამოხვედით',
  'shell.panel': 'სამართავი პანელი',
  'shell.menuClose': 'მენიუს დახურვა',
  'shell.menuCollapse': 'მენიუს შეკვეცა',
  'shell.menuExpand': 'მენიუს გაშლა',
  'shell.systemActive': 'სისტემა აქტიურია',
  'shell.modules': 'მოდულები',
  'shell.lockSystem': 'სისტემის ჩაკეტვა',
  'shell.signOutTitle': 'სისტემიდან გასვლა',
  'shell.signOut': 'გასვლა',

  'more.title': 'მეტი',
  'more.detail.suppliers': 'შესყიდვები · ვალები · ზედნადებები',
  'more.detail.staff': 'მოლარეები · შესვლა · ცვლები',
  'more.detail.orders': 'საიტიდან · მიტანა · წაღება',
  'more.detail.tools': 'ფოტოების შეკუმშვა',
  'more.detail.settings': 'კომპანია · PIN · აპარატურა',
  'more.detail.guide': 'როგორ მუშაობს პროგრამა',
  'more.detail.platform': 'ყველა მაღაზია',
  'more.terminal': 'ტერმინალის რეჟიმი',
  'more.stocktake': 'ინვენტარიზაცია',
  'more.stocktakeDetail': 'თვლა ტელეფონით',
  'more.stocktakeOwnerDetail': 'თაროზე არსებული საქონლის დათვლა',
  'more.darkMode': 'მუქი რეჟიმი',
  'more.lock': 'ჩაკეტვა',
  'more.lockDetail': 'PIN-ით, როცა სალაროს ტოვებ',

  'tab.warehouse': 'საწყობი',
  'tab.pos': 'POS',
  'tab.accounting': 'ბუღალტ.',
  'tab.credit': 'ნისია',
  'tab.more': 'მეტი',
  'tab.nav': 'მთავარი ნავიგაცია',
  'tab.moreAria': 'მეტი მოდულების გახსნა',

  'header.quickSearch': 'სწრაფი ძებნა...',
  'notif.title': 'შეტყობინებები',
  'notif.stockTitle': 'მარაგის შეტყობინებები',
  'notif.subBoth': 'გადასახდელი ხარჯი და დაბალი მარაგი',
  'notif.subStock': 'დაბალი მარაგის პროდუქცია',
  'notif.waitingAmount': 'ელოდება თანხას · {day}',
  'notif.allGood': 'ყველა მარაგი საკმარისია',
  'notif.outOfStock': 'მარაგი ამოიწურა',
  'notif.left': 'დარჩა {n} ცალი',
  'notif.goWarehouse': 'საწყობში გადასვლა →',
  'notif.more': 'და კიდევ {n}',

  'lock.pinDigits': 'PIN უნდა იყოს 4-6 ციფრი',
  'lock.pinKnown': '{pin} ყველამ იცის — სხვა აირჩიე',
  'lock.pinMismatch': 'PIN კოდები არ ემთხვევა',
  'lock.pinSet': 'PIN დაყენდა',
  'lock.setupTitle': 'ჯერ PIN აირჩიე',
  'lock.setupBody': 'ჩაკეტილ ეკრანს და კიოსკიდან გამოსვლას PIN იცავს. ამ მაღაზიას ის ჯერ არ აურჩევია, ამიტომ ახლა ნაგულისხმევი {pin} მუშაობს — მას ნებისმიერი გამოიცნობს.',
  'lock.newPin': 'ახალი PIN (4-6 ციფრი)',
  'lock.repeat': 'გაიმეორე',
  'lock.setAndLock': 'დაყენება და ჩაკეტვა',
  'lock.set': 'დაყენება',
  'lock.enterPin': 'PIN კოდი შეიყვანეთ',
  'lock.wrongPin': 'PIN კოდი არასწორია',

  'offline.off': 'ინტერნეტი გათიშულია — გაყიდვები ინახება ამ მოწყობილობაზე',
  'offline.waiting': '({n} ელოდება)',
  'offline.syncing': 'სინქრონიზაცია მიმდინარეობს...',
  'offline.pending': '{n} offline გაყიდვა ელოდება სინქრონს',
  'offline.sync': 'სინქრონიზაცია',

  'error.title': 'ამ გვერდზე შეფერხება მოხდა',
  'error.body': 'გაყიდვები და ნაშთები დაცულია — ჩაწერილი არაფერი დაკარგულა. სცადე თავიდან; თუ განმეორდება, გადაიღე ეს ეკრანი და გამომიგზავნე.',
  'error.retry': 'თავიდან ცდა',
  'error.toPos': 'სალაროზე დაბრუნება',

  'hydrate.loading': 'მონაცემები იტვირთება...',
  'hydrate.trialEnded': 'საცდელი პერიოდი დასრულდა',
  'hydrate.suspended': 'ანგარიში შეჩერებულია',
  'hydrate.staffLocked': 'მაღაზიის წვდომა დროებით შეჩერებულია — მიმართე მაღაზიის მფლობელს.',
  'hydrate.claimReceived': 'გადახდის შეტყობინება მიღებულია. ჩარიცხვის დადასტურებისთანავე მაღაზია გაიხსნება.',
  'hydrate.playTrial': 'საცდელი პერიოდი ამოიწურა — მონაცემები უცვლელია.',
  'hydrate.playSuspended': 'მაღაზიის წვდომა დროებით შეჩერებულია — მონაცემები უცვლელია.',
  'hydrate.trialPay': 'საცდელი პერიოდი ამოიწურა. გადაიხადე გამოწერა — ჩარიცხვის დადასტურებისთანავე მაღაზია გაიხსნება, მონაცემები უცვლელია.',
  'hydrate.suspendedPay': 'მაღაზიის წვდომა დროებით შეჩერებულია. თუ გამოწერის საქმეა — გადაიხადე და მაღაზია დადასტურებისთანავე გაიხსნება.',
  'hydrate.backToConsole': 'კონსოლში დაბრუნება',
  'hydrate.payDetails': 'გადახდის დეტალები',
  'hydrate.pay': 'გადახდა',
  'hydrate.toPlatform': 'პლატფორმის კონსოლზე გადასვლა...',
  'hydrate.noShop': 'მაღაზია ვერ მოიძებნა',
  'hydrate.failedTitle': 'მონაცემები ვერ ჩაიტვირთა',
  'hydrate.failedBody': 'სერვერმა დროულად ვერ უპასუხა. მაღაზია და მისი მონაცემები ხელუხლებელია — სცადე თავიდან.',
  'hydrate.retry': 'თავიდან ცდა',
  'hydrate.noShopBody': 'ამ ანგარიშს მაღაზია არ აქვს მიბმული. დაუკავშირდით ადმინისტრაციას ან შექმენით ახალი მაღაზია.',

  'theme.toLight': 'ღია რეჟიმზე გადართვა',
  'theme.toDark': 'მუქ რეჟიმზე გადართვა',
  'theme.toggle': 'თემის გადართვა',

  'branch.choose': 'ფილიალის არჩევა',
  'branch.list': 'ფილიალები',
  'branch.title': 'ფილიალი',
  'branch.main': 'მთავარი ფილიალი',
  'branch.manage': 'ფილიალების მართვა',

  'camera.title': 'შტრიხკოდის სკანირება',
  'camera.zoom': 'მასშტაბი',
  'camera.starting': 'კამერა ირთვება...',
  'camera.denied': 'კამერაზე წვდომა ვერ მოხერხდა',
  'camera.deniedHint': 'დართე ბრაუზერს კამერის ნებართვა (მისამართის ზოლში საკეტის ხატულა) და სცადე თავიდან.',
  'camera.aim': 'მიუშვირე კამერა შტრიხკოდს — ავტომატურად წაიკითხავს',
  // lib/first-day — the first-day checklist
  'fd.produce': 'პირველი წონითი პროდუქტი',
  'fd.produce.hint': 'ერთეული „კგ" და PLU კოდი — სასწორი ამით ცნობს',
  'fd.poultry.hint': 'ერთეული „კგ" — სალარო გაყიდვისას წონას ან თანხას გკითხავს',
  'fd.combo': 'თანმხლები პროდუქტი',
  'fd.combo.hint': 'ჭიქა, თავსახური, რძე — საწყობში პროდუქტის „თანმხლები (კომბო)"',
  'fd.expiry': 'ვადიანი პროდუქტი',
  'fd.expiry.hint': 'თითო მიღება თავისი ვარგისიანობით; 7 დღით ადრე გაგაფრთხილებთ',
  'fd.model': 'პირველი მოდელი ზომებით',
  'fd.model.hint': 'საწყობი → „მოდელი" — ზომები, ფერები და ეტიკეტები ერთად',
  'fd.optional': 'რჩევა',
  'fd.credit': 'ნისიის პირველი კლიენტი',
  'fd.credit.hint': 'ვის რამდენი მართებს — ნისია დილის ანგარიშშიც ჩანს',
  'fd.catalog': 'პირველი 30 პროდუქტი',
  'fd.catalog.hint': 'ბევრი პროდუქტი გაქვს? Excel-ით ყველაზე სწრაფია: საწყობი → Excel → იმპორტი',
  'fd.supplierCode': 'პირველი მიღება ზედნადებით',
  'fd.supplierCode.hint': 'RS.GE-ის ზედნადებით მიღებისას მომწოდებლის კოდი პროდუქტს ებმება — შემდეგ ზედნადებზე აპი თვითონ იცნობს',
  'fd.feed': 'წონით გასაყიდი საკვები',
  'fd.feed.hint': 'ტომრიდან კილოგრამით ყიდი? ერთეული „კგ", ტომარი კი „დაშლით" გადაიტანე',
  'fd.service': 'პირველი მომსახურება',
  'fd.service.accessories.hint': 'შუშის დაკვრა, დამცავი ბუდის მორგება — მომსახურება მარაგს არ ითვლის',
  'fd.service.stationery.hint': 'ასლი, ბეჭდვა, ლამინირება — მომსახურება მარაგს არ ითვლის',
  'fd.measured': 'მეტრით ან კილოთი გასაყიდი',
  'fd.measured.hint': 'კაბელი მეტრით, ლურსმანი კილოთი — ერთეული და წილადი რაოდენობა: 2.5 მ',
  'fd.company': 'კომპანიის მონაცემები',
  'fd.company.hint': 'სახელი და ს/კ — ჩეკზე და ინვოისზე იბეჭდება',
  'fd.categories': 'მაღაზიის ტიპი',
  'fd.categories.hint': 'აირჩიე შაბლონი — კატეგორიები ერთი დაჭერით შეიქმნება',
  'fd.cashier': 'მოლარე PIN-ით',
  'fd.cashier.hint': 'ცვლა მოლარის PIN-ით იხსნება',
  'fd.pin': 'ეკრანის ჩაკეტვის PIN',
  'fd.pin.hint': 'ნაგულისხმევი PIN ყველამ იცის — შეცვალე',
  'fd.sale': 'პირველი გაყიდვა',
  'fd.sale.hint': 'გახსენი ცვლა და გაყიდე',
  'fd.products': 'პირველი {n} პროდუქტი',
  'fd.products.hint': 'დაასკანერე ან Excel-ით შემოიტანე',
  'fd.banner.1': 'პირველი დღე',
  'fd.banner.2': '· შემდეგი: ',
  'fd.banner.3': 'გაგრძელება',
  'fd.banner.4': 'დამალვა',
  'pwa.ready': 'ახალი ვერსია მზადაა',
  'pwa.body': 'გვერდი ერთხელ განახლდება — გაყიდვა და კალათა არ დაიკარგება.',
  'pwa.later': 'მოგვიანებით',
  'pwa.reload': 'განახლება',
} as const
